module.exports = __webpack_public_path__ + "img/cow.7fbfdfea.jpg";